module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("David Groves PhD, DSc is Emeritus Professor at the University of Western Australia and Visiting Professor at China University of Geosciences Beijing. He is a Fellow of the Australian Academy of Science and has received numerous international medals and awards for his research and teaching in mineral deposit geology. On semi-retirement, he commenced writing novels using his international experience, with this being his sixth, including "), _c('em', [_vm._v("Naughty in Pink")]), _vm._v(" and its sequel "), _c('em', [_vm._v("Naughty in Australia")]), _vm._v(" for children and the two precursors to this novel entitled "), _c('em', [_vm._v("The Plagues’ Protocol")]), _vm._v(" and "), _c('em', [_vm._v("King Solomon’s Gold")]), _vm._v(" following his first novel "), _c('em', [_vm._v("The Digital Apocalypse.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0